import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PARAM_LABEL_INTERVENANT } from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import {
	CompetenceSSIAD,
	CompetenceSESSAD,
	CompetenceSAAD
} from 'src/app/shared/enums/competence.enum';
import { Address } from 'src/app/shared/models/address';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { Employee } from 'src/app/shared/models/employee/employee';
import {
	EmployeeType,
	EmployeeTypeString
} from 'src/app/shared/models/employee/employee-type';
import { Unavailability } from 'src/app/shared/models/unavailability';

@Component({
	selector: 'app-detail-employee',
	templateUrl: './detail-employee.component.html',
	styleUrls: ['./detail-employee.component.scss']
})
export class DetailEmployeeComponent implements OnInit {
	MAX_NAME_CHAR = 25;
	NAME_PATTERN = new RegExp("^[0-9a-zA-Z'éèàç._-]+( [0-9a-zA-Z'éèàç._-]+)*$");

	employee: Employee = null;
	confirmDeleteModalRef: BsModalRef;
	competences;
	isDeletable = true;

	isAreaActive = false;

	labelIntervenantCapitalized: string;

	isFormReadOnly = true;

	employeeDetailForm = new FormGroup({
		firstName: new FormControl('', [
			Validators.required,
			Validators.maxLength(this.MAX_NAME_CHAR),
			//Validators.pattern(this.NAME_PATTERN)
		]),
		lastName: new FormControl('', [
			Validators.required,
			Validators.maxLength(this.MAX_NAME_CHAR),
			//Validators.pattern(this.NAME_PATTERN)
		]),
		// address: new FormControl(new Address().label, [
		// 	Validators.required,
		// 	Validators.maxLength(60)
		// ]),
		birthDate: new FormControl<Date>(null),
		telephone: new FormControl('', Validators.pattern('0{1}[0-9]{9}')),
		statutInt: new FormControl('', Validators.required),
		email: new FormControl('', Validators.email),
		nomStructure: new FormControl(''),
		typeStructure: new FormControl(),
		addressStructure: new FormControl(new Address().label, [
			Validators.maxLength(60)
		]),
		emailStructure: new FormControl('', Validators.email),
		phoneStructure: new FormControl('', Validators.pattern('0{1}[0-9]{9}')),
		username: new FormControl('')
	});

	isAddressSelected: { value: boolean } = { value: false };
	isAddressDefault: { value: boolean } = { value: true };

	unavailabilitiesMapped: {
		id: number;
		startDate: Date;
		endDate: Date;
	}[] = [];

	newUnavailability: Unavailability = new Unavailability();
	newUnavailabilityMapped: { id: number; startDate: Date; endDate: Date } = {
		id: undefined,
		startDate: undefined,
		endDate: undefined
	};
	isUnavaibilityTimeValid = true;

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked: { value: boolean } = { value: false };

	//Employé.e extérieur
	isEmpExt = false;

	public EmployeeTypeStringEnum = EmployeeTypeString;
	public EmployeeType = EmployeeType;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private modalService: BsModalService,
		private facade: FacadeService
	) {}

	ngOnInit(): void {
		this.isAreaActive = this.facade.dataStorageService.isAreaActive();
		this.labelIntervenantCapitalized =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_INTERVENANT
			);

		const id = +this.route.snapshot.paramMap.get('id');
		this.facade.employeeService
			.getEmployeeById(id)
			.subscribe((employee: Employee) => {
				this.employee = employee;
				this.isEmpExt = this.employee.statutInt === EmployeeType.EXT ? true : false;
				if (
					this.employee.address !== null &&
					this.employee.address.label !== null &&
					this.employee.address.label !== ''
				) {
					this.isAddressDefault.value = true;
				}
				this.resetForm();

			});
	}

	goBack(): void {
		this.router.navigate(['/gestion/employees/list']);
	}

	delete(employee: Employee): void {
		if (this.isDeletable) {
			this.facade.employeeService.deleteEmployee(employee.id).subscribe({
				complete: () => {
					this.modalService.hide();
					this.goBack();
				},
				error: (err: ErrorResponse) => {
					console.log(err);
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.modalService.hide();
				}
			});
		}
	}

	openConfirmDeleteModal(confirmDeleteTemplate: TemplateRef<any>): void {
		this.confirmDeleteModalRef = this.modalService.show(confirmDeleteTemplate);
	}

	editForm() {
		this.isFormReadOnly = false;
	}

	stopEditForm(isSubmit: boolean) {
		this.isFormReadOnly = true;
		this.isValidateButtonClicked.value = false;

		if (isSubmit) {
			this.facade.employeeService.getEmployeeById(this.employee.id).subscribe({
				next: (employee: Employee) => {
					this.employee = employee;
					this.resetForm();
				},
				error: (err) => {
					this.isValidateButtonClicked.value = false;
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.resetForm();
				}
			});
		}
	}

	onSubmit() {
		if (
			this.employeeDetailForm.valid &&
			(this.isAddressSelected.value || this.isAddressDefault.value)
		) {
			this.facade.employeeService.updateEmployee(this.employee).subscribe({
				complete: () => {
					// this.facade.toastService.createSuccessToast();
					this.stopEditForm(true);
				},
				error: (err) => {
					this.isValidateButtonClicked.value = false;
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					// On va chercher la nouvelle version de l'employé
					this.facade.employeeService
						.getEmployeeById(this.employee.id)
						.subscribe((employee: Employee) => {
							this.employee = employee;
							this.resetForm();
						});
				}
			});
		} else {
			this.isValidateButtonClicked.value = false;
			// this.facade.toastService.createErrorToast();
		}
	}

	resetForm() {
		this.employeeDetailForm.reset();
		this.employeeDetailForm.patchValue({
			firstName: this.employee.firstName,
			lastName: this.employee.lastName,
			//address: this.employee.address.label,
			birthDate:
				this.employee.birthDate !== null && this.employee.birthDate !== ''
					? new Date(this.employee.birthDate)
					: null,
			telephone: this.employee.telephone,
			statutInt: this.employee.statutInt,
			email: this.employee.email,
			nomStructure: this.employee.nomStructure,
			typeStructure: this.employee.typeStructure?.id,
			addressStructure: this.employee.addressStructure.label,
			emailStructure: this.employee.emailStructure,
			phoneStructure: this.employee.phoneStructure,
			username:this.employee.username
		})
	}

	expertisesAsString() {
		let str = '';
		this.employee.expertises
			.sort((a, b) => a.name.localeCompare(b.name))
			.forEach((e) => (str += e.name + ', '));
		return str.slice(0, -2);
	}

	get firstName() {
		return this.employeeDetailForm.get('firstName');
	}
	get lastName() {
		return this.employeeDetailForm.get('lastName');
	}
	// get address() {
	// 	return this.employeeDetailForm.get('address');
	// }
	get competence() {
		return this.employeeDetailForm.get('competence');
	}
	get telephone() {
		return this.employeeDetailForm.get('telephone');
	}
	get statutInt() {
		return this.employeeDetailForm.get('statutInt');
	}
	get email() {
		return this.employeeDetailForm.get('email');
	}
	get username() {
		return this.employeeDetailForm.get('username');
	}
	get nomStructure() {
		return this.employeeDetailForm.get('nomStructure');
	}
	get typeStructure() {
		return this.employeeDetailForm.get('typeStructure');
	}
	get emailStructure() {
		return this.employeeDetailForm.get('emailStructure');
	}
	get phoneStructure() {
		return this.employeeDetailForm.get('phoneStructure');
	}
	get addressStructure() {
		return this.employeeDetailForm.get('addressStructure');
	}

	
}
